import { render, staticRenderFns } from "./ExpressOrdersModule.vue?vue&type=template&id=251eda5f"
import script from "./ExpressOrdersModule.vue?vue&type=script&lang=js"
export * from "./ExpressOrdersModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports